<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div id="CategoryOverTimeSettings" class="gridItemSettingsPanelCustomSettingsBottomItem"
         cvModuleCxoneCustomSettingSection [moduleManager]="moduleManager" after="emp">
    </div>
</ng-container>
